module.exports = __webpack_public_path__ + "static/img/zl.2607a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zl.png
// module id = YD82
// module chunks = 72